<template>
    <RouterLink :to="`/organizations/${organizationId}/group`"
        class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
        <img :src="detailsBlade1" width="24" height="24" alt="">
        <img :src="profileIcon">
        <p class="rlms-fw-500" id="name-text">{{ group?.name }}</p>
    </RouterLink>
    <div class="box-lr-wrapper">
        <!-- Left Section -->
        <div class="box-left rlms-flex rlms-flex-col rlms-gap-20">
            <!-- Authorized Users -->
            <div class="detail-box rlms-border rlms-br-16">
                <div class="detail-box-head rlms-border-bottom">
                    <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
                        <span class="rlms-fw-500 rlms-sm-sm">Authorized User</span>
                        <div class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer"
                            @click="showAuthorizedUserModal = true">
                            <img :src="detailsBlade3" width="24" height="25" alt="" />
                            <p class="rlms-text-primary-500">Add User</p>
                        </div>
                    </div>
                </div>
                <template v-if="authorizedUser.length">
                    <div class="rlms-table">
                        <div class="rlms-table-inner">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Permission</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="user in authorizedUser" :key="user.id">
                                        <td>
                                            <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                                <img :src="user?.profile_picture ?? profileIcon">
                                                <div class="rlms-flex rlms-flex-col">
                                                    <div class="rlms-fw-500">{{ user?.firstname }} {{
                                                        user?.lastname
                                                    }}<br />{{ user?.email }}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            {{capitalize(permissions.find(i => i.id === user.permission_id)?.name)}}
                                        </td>
                                        <td class="rlms-text-danger-500">
                                            <span class="rlms-cursor-pointer rlms-popup-btn remove-learner"
                                                @click="deleteAuthrizedUser(user.group_user_id)">Remove</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>
                <div class="detail-box-body rlms-flex rlms-flex-col rlms-gap-20 rlms-text-center rlms-justify-center"
                    style="min-height: 200px" v-else>
                    <div class="rlms-avatar-group rlms-justify-center">
                        <div v-for="n in 3" :key="n" class="rlms-avatar">
                            <img :src="defaultImage" />
                        </div>
                    </div>

                    <p v-if="true">
                        Currently there are no authorized users in the group. Tap the 'Add User' button to add one.
                    </p>
                </div>
            </div>

            <!-- Learners -->
            <div class="detail-box rlms-border rlms-br-16">
                <div class="detail-box-head rlms-border-bottom">
                    <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
                        <span class="rlms-fw-500 rlms-sm-sm">Learners</span>
                        <div class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer"
                            @click="$emit('addLearner')">
                            <img :src="detailsBlade3" width="24" height="25" alt="" />
                            <p class="rlms-text-primary-500" @click="showAddLearnerModal = true">Add Learner</p>
                        </div>
                    </div>
                </div>
                <div class="rlms-table" v-if="group?.learners?.length">
                    <div class="rlms-table-inner">
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="learner in group?.learners" :key="learner.id">
                                    <td>
                                        <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                            <img :src="profileIcon">
                                            <div class="rlms-flex rlms-flex-col">
                                                <div class="rlms-fw-500">{{ learner?.firstname }} {{ learner?.lastname
                                                    }}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="rlms-text-danger-500">
                                        <span class="rlms-cursor-pointer rlms-popup-btn remove-learner"
                                            @click="deleteLearners(learner.id)">Remove</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="detail-box-body rlms-flex rlms-flex-col rlms-gap-30 rlms-text-center" v-else>
                    <img :src="learnerImage" class="rlms-mx-auto" style="width: 100px" />
                    <p>No Learners Available to be added to this group</p>
                </div>
            </div>
        </div>

        <!-- Right Section -->
        <div class="box-right rlms-flex rlms-flex-col rlms-gap-20">
            <div class="detail-box rlms-border rlms-br-16">
                <div class="detail-box-head rlms-border-bottom">
                    <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
                        <span class="rlms-fw-500 rlms-sm-sm">Group</span>
                        <div class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer"
                            @click="showModal = true">
                            <img :src="detailsBlade2" width="24" height="24" alt="" />
                            <p class="rlms-text-primary-500">Edit</p>
                        </div>
                    </div>
                </div>
                <div class="detail-box-body" id="general-info-content">
                    <ul class="db-ul-style-3">
                        <li>
                            <span class="rlms-fs-xs rlms-text-extra-3 rlms-fw-500">Name</span>
                            <p>{{ formatDate(group?.name) }}</p>
                        </li>
                        <li>
                            <span class="rlms-fs-xs rlms-text-extra-3 rlms-fw-500">Description</span>
                            <p>{{ group?.description || '-' }}</p>
                        </li>
                        <li>
                            <span class="rlms-fs-xs rlms-text-extra-3 rlms-fw-500">Created</span>
                            <p>{{ formatDate(group?.created_at) }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <AddEditGroupModal v-if="showModal" @close="showModal = false;" @saved="init()" :organizationId="organizationId"
        :group="group" />

    <BaseModal :visible="showAddLearnerModal" title="Add Learner In Group" size="small" id="change__your__photo__popup"
        class="change__your__photo__popup" @close="showAddLearnerModal = false">

        <div class="short__note__info">
            <p>Select Learners to Add in the group</p>
        </div>

        <div class="popup-scrolled-y rlms-flex rlms-flex-col rlms-gap-20" style="max-height: 300px;">
            <label class="rlms-us-none rlms-flex rlms-items-center rlms-gap-10" v-for="learner in learners"
                :key="learner.id">
                <input type="checkbox" :value="learner?.id" class="rlms-checkbox" v-model="selectedLearners">
                <img :src="profileIcon">
                <span>{{ learner?.firstname }} {{ learner?.lastname }}</span>
            </label>
        </div>
        <template #footer>
            <div class="pp-footer" style="padding: 0;">
                <button class="rlms-btn rlms-btn-outline-primary pp-close-btn" type="button"
                    @click="showAddLearnerModal = false">Cancel</button>
                <button class="rlms-btn rlms-btn-primary add-learner" type="submit"
                    @click="saveLearners(false)">Save</button>
            </div>
        </template>
    </BaseModal>

    <AddGroupAuthorizedUserModal v-if="showAuthorizedUserModal" @close="showAuthorizedUserModal = false" @saved="init()"
        :organizationId="organizationId" :permissions="permissions" :groupId="groupId" />
</template>
<script setup>
import defaultImage from "@/assets/images/no-image.png";
import learnerImage from "@/assets/images/kids-reading-book.png";
import confirmationIcon from '@/assets/images/confirmation.png';
import { useRoute } from 'vue-router'
import { capitalize, onMounted, ref } from 'vue'
import axios from "@/services/axios";
import { formatDate } from '@/utils/format-helpers';
import AddEditGroupModal from "@/components/AddEditGroupModal.vue";
import { handleError } from "@/utils/handleError";
import BaseModal from "@/components/BaseModal.vue";
import { showConfirmDialog, showToast } from "@/utils/swal";
import { useLoaderStore } from "@/stores/loader";
import detailsBlade1 from '@/assets/images/details_blade_587e9213.svg'
import profileIcon from '@/assets/images/profile.svg'
import detailsBlade2 from '@/assets/images/details_blade_00794713.svg'
import detailsBlade3 from '@/assets/images/details_blade_4980d43e.svg'
import AddGroupAuthorizedUserModal from "@/components/AddGroupAuthorizedUserModal.vue";

const route = useRoute();
const loader = useLoaderStore();

const organizationId = Number(route.params.organization ?? 0);
const groupId = Number(route.params.groupId ?? 0);
const group = ref(null);
const learners = ref([]);
const permissions = ref([]);
const showModal = ref(false);
const showAddLearnerModal = ref(false);
const showAuthorizedUserModal = ref(false);
const authorizedUser = ref([]);

const selectedLearners = ref([]);

onMounted(async () => {
    init();
});

const init = () => {
    showModal.value = false;
    showAddLearnerModal.value = false;
    showAuthorizedUserModal.value = false;
    fetchData();
}

const fetchData = async () => {
    try {
        loader.show();

        const { data } = await axios.get(`/organizations/${organizationId}/groups/${groupId}`);
        learners.value = data.data?.learners || [];
        permissions.value = data.permissions || [];
        group.value = data.data.groups;
        authorizedUser.value = data.data.groups?.users || [];
        const learnerIds = group.value?.learners?.map(learner => learner.id) || [];
        selectedLearners.value = learnerIds;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const saveLearners = async (deleted = false) => {
    try {
        loader.show();
        await axios.post(`/organizations/${organizationId}/groups/${groupId}/add-learner`, {
            selected_learner: selectedLearners.value
        });

        fetchData();
        showAddLearnerModal.value = false;

        showToast({
            icon: 'success',
            title: 'Success!',
            text: deleted ? `Learner removed successfully` : `Learners save successfully!`
        });

    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

const deleteLearners = async (learnerId) => {
    const result = await showConfirmDialog({
        title: 'Are you sure?',
        html: `<div class="rlms-flex rlms-flex-col rlms-gap-20">
            <p id="text-message">Are you sure you want to delete the learner from this group?</p>
            <span class="rlms-text-danger-500" id="delete-confirm"> This action will permanently remove and cannot be
                undone. </span>
        </div>`,
        confirmButtonText: 'Delete',
        imageUrl: confirmationIcon
    });

    if (result.isConfirmed) {
        selectedLearners.value = selectedLearners.value.filter(item => item !== learnerId);
        saveLearners(true);
    }
}

const deleteAuthrizedUser = async (group_user_id) => {
    const result = await showConfirmDialog({
        title: 'Are you sure?',
        html: `<div class="rlms-flex rlms-flex-col rlms-gap-20">
            <p id="text-message">Are you sure you want to delete the user from this group?</p>
            <span class="rlms-text-danger-500" id="delete-confirm"> This action will permanently remove and cannot be
                undone. </span>
        </div>`,
        confirmButtonText: 'Delete',
        imageUrl: confirmationIcon
    });

    if (result.isConfirmed) {
        try {
            loader.show();
            await axios.post(`/organizations/${organizationId}/groups/${groupId}/delete-authorized-user`, {
                id: group_user_id
            });

            fetchData();

            showToast({
                icon: 'success',
                title: 'Success!',
                text: `User removed successfully.`
            });

        } catch (error) {
            handleError(error);
        } finally {
            loader.hide();
        }
    }
}

</script>